import {MenuProductType} from '../../../../types/Menu';

export function isMenuProduct(x: unknown): x is MenuProductType {
  return (
    x !== null &&
    typeof x === 'object' &&
    'name' in x &&
    'price' in x &&
    'scancode' in x
  );
}
